import { Injectable } from '@angular/core';
import { EventDataService } from '../data/event-service';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  forkJoin,
  of,
} from 'rxjs';
import { map, switchMap, first, mergeAll } from 'rxjs/operators';
import {
  EventGetModel,
  EventAddModel,
  TicketPrice,
} from '../interfaces/interfaces';
import { PassDataService } from '../services/pass-data.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class EventLogicService {
  deleteId: string = '';
  deleteImagesName: string[] = [];

  constructor(
    private eventDataService: EventDataService,
    private passDataService: PassDataService
  ) { }

  getAllEventsLogic(): Observable<EventGetModel[]> {
    return this.eventDataService.getAllEventsData().pipe(
      switchMap((d) => {
        let events = [];
        for (let i = 0; i < d.length; i++) {
          let event = d[i] as EventGetModel;

          const startDateToShow = moment(event.startDate).format("DD-MM-YYYY, hh:mm A");
          const endDateToShow = moment(event.endDate).format("DD-MM-YYYY, hh:mm A")

          let eventModel = new EventGetModel(
            event._id,
            event.title,
            event.description,
            event.location,
            event.startDate,
            event.endDate,
            event.ticketType,
            event.ticketPrice,
            event.registerLink,
            event.imageUrls,
            startDateToShow,
            endDateToShow
          );

          events.push(eventModel);
        }
        return [events];
      })
    );
  }

  async addEventLogic(
    title: string,
    description: string,
    location: string,
    startDate: string,
    endDate: string,
    ticketType: string,
    ticketPrice: TicketPrice[],
    registerLink: string,
    files: File[]
  ) {
    const imageLinks = await this.eventDataService.uploadEventImageData(files);
    return this.eventDataService.addEventData(
      new EventAddModel(
        title,
        description,
        location,
        startDate,
        endDate,
        ticketType,
        ticketPrice,
        registerLink,
        imageLinks
      )
    )
  }

  async updateEventLogic(
    id: string,
    title: string,
    description: string,
    location: string,
    startDate: string,
    endDate: string,
    ticketType: string,
    ticketPrice: TicketPrice[],
    registerLink: string,
    files: any,
    imageUrls: string[]
  ) {

    let imageLinks: any[] = [];

    if (files.length !== 0) {
      imageLinks = await this.eventDataService.uploadEventImageData(files);
      imageUrls.push(...imageLinks)
      return this.eventDataService.updateEventData(
        new EventGetModel(
          id,
          title,
          description,
          location,
          startDate,
          endDate,
          ticketType,
          ticketPrice,
          registerLink,
          imageUrls
        )
      )
    } else {
      return this.eventDataService.updateEventData(
        new EventGetModel(
          id,
          title,
          description,
          location,
          startDate,
          endDate,
          ticketType,
          ticketPrice,
          registerLink,
          imageUrls
        )
      )
    }
  }

  async deleteEventLogic(data: any) {
    const resp = await this.eventDataService.deleteEventData(data?._id, data?.imageUrls);
    //console.log(resp)
    return resp
  }

  async deleteEventImageLogic(eventId: string, link: string, links: string[]) {
    const data = await this.eventDataService.deleteEventImageAndUpdate(eventId, link, links);
    if(data == "success") {
      const filter = links.filter(f => f !== link);
      await this.eventDataService.updateEventImageData(eventId, filter)
      return { message: "success", links: filter }
    } else {
      return "error"
    }
  }
}
